export const showLoading = () => {
    return{
        type: 'SHOW_LOADING',
        payload: true
    }
}

export const hideLoading = () => {
    return{
        type: 'SHOW_LOADING',
        payload: false
    }
}


// WEBPACK FOOTER //
// ./src/LoadingComponent/actions.js